<template>
    <div v-if="!value">
    <v-btn color="blue">
        Login
        <v-dialog
            v-model="dialog"
            max-width="500"
            persistent
        >
        <v-card>
            <v-card-title align="center">
                Login
            </v-card-title>
            <v-card-text>
                <v-row align="center">
                    <v-col cols="6">
                        <v-text-field
                            label="ID"
                            type="text"
                            v-model="name"
                        >
                        </v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                            label="PW"
                            type="password"
                            v-model="password"
                        >
                        </v-text-field>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col>
                        <v-btn color="primary" @click="login">
                            Login
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        </v-dialog>
    </v-btn>
    </div>
    <div v-else>
    <v-btn color="blue" @click="logout()">
        Logout
    </v-btn>
    </div>
</template>

<script>
import axios from 'axios'
import jwt_decode from "jwt-decode";
export default {
    name: 'LoginBtn',
    props: [
        'value'
    ],
    data() {
        return {
            dialog: !this.value,
            name: '',
            password: '',
        }
    },
    methods: {
        login() {
            axios.post(`${process.env.VUE_APP_BACKEND}/login`, {name:this.name, password:this.password}).then((res) => {
                localStorage.setItem('_session_', res.headers._session_);
                localStorage.setItem('_session_role_', jwt_decode(res.headers._session_).data.ROLE)
                this.$emit('input', true);
            }).catch(() => {
                this.logout();
            });
            this.name = ''
            this.password = ''
            this.dialog = false;
        },
        logout() {
            localStorage.removeItem('_session_');
            localStorage.removeItem('_session_role_');
            this.$emit('input', false);
            this.dialog = true;
        },
        refresh() {
            var token = localStorage.getItem('_session_')
            if (token) {
                axios.post(`${process.env.VUE_APP_BACKEND}/refresh`,{token}).then((res) => {
                    localStorage.setItem('_session_', res.headers._session_);
                    localStorage.setItem('_session_role_', jwt_decode(token).data.ROLE)
                    this.$emit('input', true);
                }).catch(() => {
                    this.logout();
                });
            }
        }
    },
    created() {
        setInterval(() => {
            this.refresh()
        }, 3 * 60 * 1000);
        this.refresh();
    }
}
</script>
